export type DebugSettings = {
    enabled: boolean;
    loggerNamespaces: string;
    showRestartActiveMeetingPageButton: boolean;
    disableRoomLeaveBlocker: boolean;
    enableAllBrowsers: boolean;
    showVideoInfo: boolean;
    showSpeakerListInfoDialog: boolean;
};

export const defaultDebugSettings: DebugSettings = {
    enabled: window.debugEnabled,
    loggerNamespaces: "JsSIP:*,Conference:*",
    showRestartActiveMeetingPageButton: true,
    disableRoomLeaveBlocker: true,
    enableAllBrowsers: true,
    showVideoInfo: true,
    showSpeakerListInfoDialog: false,
};
